import { Injectable } from "@angular/core";
import { HttpClient } from './http-client';
import { dateToUnixTime } from '../utils/DateHelper';
import { DEFAULT_PAGE_SIZE } from "./services-constants";
import { Response } from '@angular/http';
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import { MdSnackBar } from '@angular/material';
import { PermisosService, PERM_ACCIONES_ID } from './permisos-service';
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {ConnectionPositionPair, OverlayConnectionPosition} from '@angular/cdk/typings/overlay';
import {PriceSimulateViewModel} from '@utils/ViewModels';

export const PIZARRA_COLUMNS = {
  MERCADO: 'Mercado',
  COTIZACION: 'Cotización',
  PUBLICACION: 'Publicación',
  SOJA: 'Soja',
  MAIZ: 'Maiz',
  TRIGO: 'Trigo',
  GIRASOL: 'Girasol',
  SORGO: 'Sorgo',
  RESPONSABLE: 'Responsable',
  VALIDADOR: 'Validador'
};

@Injectable()
export class PreciosService {

  private checkPrecioInterval: any;
  private checkPrecioFlag = false;
  private checkPrecioSource = new BehaviorSubject<boolean>(false);
  checkPrecioFlag$ = this.checkPrecioSource.asObservable();

  private checkPrecioPizarraInterval: any;
  private checkPrecioPizarraFlag = false;
  private checkPrecioPizarraSource = new BehaviorSubject<boolean>(false);
  checkPrecioPizarraFlag$ = this.checkPrecioPizarraSource.asObservable();
  private checkPrecioFinancieraInterval: any;
  private checkPrecioFinancieraFlag = false;
  private checkPrecioFinancieraSource = new BehaviorSubject<boolean>(false);
  checkPrecioFinancieraFlag$ = this.checkPrecioFinancieraSource.asObservable();
  // mercados
  mercadosSource = new BehaviorSubject<any>(null);

  public positionPairLeft: ConnectionPositionPair = { overlayX: 'end', overlayY: 'top', originX: 'end', originY: 'bottom'}
  public positionPairRight: ConnectionPositionPair = { overlayX: 'start', overlayY: 'top', originX: 'start', originY: 'bottom'}

  constructor(private httpClient: HttpClient,
              private snackBar: MdSnackBar,
              private permisosService: PermisosService) {
    this.getMercadosPizarra(true).subscribe(x => {
      if (x) {
        this.mercadosSource.next(x);
      }
    });
  }

  getGrillaPrecios(page: number, columnOrder: string, ascending: boolean, productId: number, fromDate: number, toDate: number, negocioFilter: string,
      idPosicion: number, idMoneda: number, idEntrega: number, idUsuarios: Array<number>, productFilter: Array<any>, validadorFilter: Array<number>, filterProductoIds: Array<number>, filterMercado: number) {
      const request = {
          PageSize: DEFAULT_PAGE_SIZE,
          PageNumber: page,
          ColumnOrder: columnOrder,
          AscendingOrder: ascending,
          IdProducto: productId,
          FromDate: fromDate,
          ToDate: toDate,
          Negocio: negocioFilter,
          IdPosicion: idPosicion,
          IdEntrega: idEntrega,
          IdMoneda: idMoneda,
          FilterResponsable: idUsuarios,
          Products: productFilter,
          FilterValidador: validadorFilter,
          ProductsIds: filterProductoIds,
          IdMercado: filterMercado,
      };
      return this.httpClient.post('/api/precio/grilla', request)
          .map((response: Response) => {
              return response.json();
          });
  }

  getMonitorPrecios(fecha: Date, producto: number, moneda: number, posicion: number, entrega: number, users: Array<number>, validadores: Array<number>, esHoy: boolean, mercados: number[]) {
      const request: any = {
          EsFechaHoy: esHoy,
          Fecha: dateToUnixTime(fecha),
          IdPosicion: posicion,
          IdMoneda: moneda,
          IdProducto: producto,
          IdUsuarios: users,
          IdEntrega: entrega,
          IdUsuariosValidador: validadores,
          IdMercados: mercados,
      };
      return this.httpClient.post('/api/precio/monitor', request)
          .map((response: Response) => {
              return response.json();
          });
  }

  addPrecio(precios) {
    return this.httpClient.post('/api/precio/', precios)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getTonsByPrice(precio) {
    return this.httpClient.post('/api/precio/get-tons-by-price/', precio)
      .map((response: Response) => {
        return response.json();
      });
  }

  simulatePrecios(precios): Observable<PriceSimulateViewModel> {
    return this.httpClient.post('/api/precio/emulate', precios)
      .map((response: Response) => {
        const ret = response.json().ResponseData as PriceSimulateViewModel;
        if (ret.Negocios.length && ret.Negocios[0].hasOwnProperty('Pesificar')) {
          ret.Negocios.forEach(x => x.Moneda = x.Pesificar ? {Id: -1, Moneda: 'Dólares a Pesificar', Simbolo: 'u$p' } : x.Moneda);
        }
        return ret;
      });
  }

  getPreciosToValidate() {
    return this.httpClient.get('/api/precio/prices-for-review')
      .map((response: Response) => {
        return response.json();
      });
  }

  rechazarPrecio(precioId) {
    return this.httpClient.post(`/api/precio/reject-price/${precioId}`, {})
      .map((response: Response) => {
        return response.json();
      });
  }

  publicarPrecios(precios) {
    return this.httpClient.post(`/api/precio/publish`, precios)
      .map((response: Response) => {
        return response.json();
      });
  }

  // checkNewComunicadosActivity() {
  //   const userId = localStorage.getItem('userId');
  //   // check activities once the user is logged in
  //   if (userId) {
  //     return this.httpClient.get(`/api/actividad/are-new-Precio-activity/${userId}`)
  //       .map((response: Response) => {
  //         if (response) {
  //           return response.json().ResponseData;
  //         }
  //       });
  //   } else {
  //     return Observable.from([]);
  //   }
  // }

  getAreNewPricesForReview() {
    const userId = localStorage.getItem('userId');
    // check activities once the user is logged in
    if (userId) {
      return this.httpClient.get('/api/precio/are-new-prices-for-review')
        .map((response: Response) => {
          if (response) {
            return response.json().ResponseData;
          }
        });
    } else {
      return Observable.from([]);
    }
  }

  getAreNewPricesPizarraForReview() {
    const userId = localStorage.getItem('userId');
    // check activities once the user is logged in
    if (userId) {
      return this.httpClient.get('/api/precio/cotizacionBCR/are-new-for-review')
        .map((response: Response) => {
          if (response) {
            return response.json().ResponseData;
          }
        });
    } else {
      return Observable.from([]);
    }
  }

  getAreNewPricesFinancieraForReview() {
    const userId = localStorage.getItem('userId');
    // check activities once the user is logged in
    if (userId) {
      return this.httpClient.get('/api/precio/cotizacion/are-new-for-review')
        .map((response: Response) => {
          if (response) {
            return response.json().ResponseData;
          }
        });
    } else {
      return Observable.from([]);
    }
  }

  checkNewPricesForReview() {
    this.cancelCheckActivities();
    if (this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_ValidarPrecio)) {
      this.getAreNewPricesForReview()
        .subscribe(value => {
          this.setBubbleValues(value, 'precio');
        });
      this.checkPrecioInterval = setInterval(() => {
        this.getAreNewPricesForReview()
          .subscribe(value => {
            this.setBubbleValues(value, 'precio');
          });
      }, 30 * 1000);
    }

    if (this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_ValidarPrecioPizarra)) {
      this.getAreNewPricesPizarraForReview()
        .subscribe(value => {
          this.setBubbleValues(value, 'pizarra');
        }, err => this.setBubbleValues(false, 'pizarra'));
      this.checkPrecioPizarraInterval = setInterval(() => {
        this.getAreNewPricesPizarraForReview()
          .subscribe(value => {
            this.setBubbleValues(value, 'pizarra');
          }, err => this.setBubbleValues(false, 'pizarra'));
      }, 30 * 1000);
    }

    if (this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.A_ValidarPrecioFinanciera)) {
      this.getAreNewPricesFinancieraForReview()
        .subscribe(value => {
          this.setBubbleValues(value, 'financiera');
        }, err => this.setBubbleValues(false, 'financiera'));
      this.checkPrecioFinancieraInterval = setInterval(() => {
        this.getAreNewPricesFinancieraForReview()
          .subscribe(value => {
            this.setBubbleValues(value, 'financiera');
          }, err => this.setBubbleValues(false, 'financiera'));
      }, 30 * 1000);
    }
  }

  cancelCheckActivities() {
    clearInterval(this.checkPrecioInterval);
    clearInterval(this.checkPrecioPizarraInterval);
    clearInterval(this.checkPrecioFinancieraInterval);
  }

  setBubbleValues(value, type) {
    if (type === 'precio') {
      if (value && !this.checkPrecioFlag) {
        this.snackBar.open('Hay nuevos precios para validar', '', {
          duration: 3000,
        });
      }
      this.checkPrecioFlag = value;
      this.checkPrecioSource.next(this.checkPrecioFlag);
    } else if (type === 'pizarra') {
      if (value && !this.checkPrecioPizarraFlag) {
        this.snackBar.open('Hay nuevos precios de pizarra para validar', '', {
          duration: 3000,
        });
      }
      this.checkPrecioPizarraFlag = value;
      this.checkPrecioPizarraSource.next(this.checkPrecioPizarraFlag);
    } else if (type === 'financiera') {
      if (value && !this.checkPrecioFinancieraFlag) {
        this.snackBar.open('Hay nuevos precios de cotizacion financiera para validar', '', {
          duration: 3000,
        });
      }
      this.checkPrecioFinancieraFlag = value;
      this.checkPrecioFinancieraSource.next(this.checkPrecioFinancieraFlag);
    }
  }

  getPrecioToValidateFlag() {
    return this.checkPrecioFlag;
  }

  getPrecioPizarraToValidateFlag() {
    return this.checkPrecioPizarraFlag;
  }

  getPrecioFinancieraToValidateFlag() {
    return this.checkPrecioFinancieraFlag;
  }

  getCotizacionDolar() {
    return this.httpClient.get('/api/precio/cotizacionBCRA')
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getPizarraMonitor(mercados) {
    const payload = {
      IdMercados: mercados
    }
    return this.httpClient.post('/api/precio/cotizacionBCR/monitor', payload)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getPizarraGrilla(page: number,
                   columnOrder: string,
                   ascending: boolean,
                   productId: number,
                   fromDate: number,
                   toDate: number,
                   idUsuarios: Array<number>,
                   productFilter: Array<any>,
                   validadorFilter: Array<number>,
                   publicacionFromDate: number,
                   publicacionToDate: number,
                   mercadoId: number) {
    const request = {
      PageSize: DEFAULT_PAGE_SIZE,
      PageNumber: page,
      ColumnOrder: columnOrder,
      AscendingOrder: ascending,
      IdProducto: productId,
      FromDate: fromDate,
      ToDate: toDate,
      FilterResponsable: idUsuarios ? idUsuarios : [],
      Products: productFilter,
      FilterValidador: validadorFilter ? validadorFilter : [],
      CotizacionFromDate: publicacionFromDate,
      CotizacionToDate: publicacionToDate,
      IdMercado: mercadoId
    };
    return this.httpClient.post('/api/precio/cotizacionBCR/grilla', request)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getPreciosToValidatePizarra() {
    return this.httpClient.get('/api/precio/cotizacionBCR/validador')
      .map((response: Response) => {
        return response.json().ResponseData;
      });
    // return Observable.from([
    //   [{
    //     Fecha: '2019-10-29T15:14:12.45',
    //     Id: 7534,
    //     Usuario: {
    //       UserId: 149,
    //       UserFullName: 'STEEE Men',
    //       UserName: 'STEEE Men'
    //     },
    //     Precio: 170,
    //     Producto: {
    //       Producto: 'Caramelos'
    //     }
    //   }, {
    //     Fecha: '2019-11-29T15:14:12.45',
    //     Id: 7535,
    //     Usuario: {
    //       UserId: 150,
    //       UserFullName: 'Ste Otro men',
    //       UserName: 'Ste Otro men'
    //     },
    //     Precio: 180,
    //     Producto: {
    //       Producto: 'Caramelos'
    //     },
    //   }]
    // ]);
  };

  rechazarPrecioPizarra(precioId) {
    return this.httpClient.post(`/api/precio/cotizacionBCR/rechazar/${precioId}`, {})
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  // validar los precios
  publicarPreciosPizarra(precios) {
    return this.httpClient.post(`/api/precio/cotizacionBCR/publish`, precios)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  // enviar a validacion los precios de pizarra
  crearPreciosPizarra(precios) {
    return this.httpClient.post(`/api/precio/cotizacionBCR`, precios)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getMercadosPizarra(all = false) {
    // por defecto traemos los mercados filtrando los no visibles a excepcion del ABM donde necesitamos todos
    return this.httpClient.get('/api/precio/cotizacionBCR/get-mercados')
      .map((response: Response) => {
        return all ? response.json().ResponseData : response.json().ResponseData.filter(y => y.Visibilidad);
      });
  }

  toggleMercadoVisibilidad(mercadoId) {
    return this.httpClient.get(`/api/precio/cotizacionBCR/toggle-mercado-visibilidad/${mercadoId}`)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  crearMercado(mercado) {
    return this.httpClient.post(`/api/precio/cotizacionBCR/create-mercado`, mercado)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  editarMercado(mercado) {
    return this.httpClient.post(`/api/precio/cotizacionBCR/edit-mercado`, mercado)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/precios-service.ts